<template>
    <b-card-body class="pb-0">

        <div v-if="loading" class="text-muted">Henter Økoskabet information...</div>

        <div v-else-if="!okoskabet" class="text-muted">
            Ingen Økoskabet forsendelse oprettet for denne ordre.
        </div>

        <div v-else>
            <h6 class="text-uppercase text-muted mb-2">Forsendelse</h6>
            <dl class="row mb-3">
                <dt class="col-sm-4">Status</dt>
                <dd class="col-sm-8">
                    <b-badge :variant="statusVariant">{{ okoskabet.status || "Ukendt" }}</b-badge>
                </dd>

                <dt class="col-sm-4">Forsendelses-ID</dt>
                <dd class="col-sm-8">{{ okoskabet.shipmentId || "-" }}</dd>

                <dt class="col-sm-4">Reference</dt>
                <dd class="col-sm-8">{{ okoskabet.shipmentReference || "-" }}</dd>

                <template v-if="okoskabet.unprocessableUrl">
                    <dt class="col-sm-4">Skal rettes</dt>
                    <dd class="col-sm-8">
                        <a :href="okoskabet.unprocessableUrl" target="_blank" rel="noopener">Åbn i backoffice</a>
                    </dd>
                </template>

                <dt class="col-sm-4">Oprettet</dt>
                <dd class="col-sm-8">
                    {{ formatDate(okoskabet.createdAt) }}
                    <span v-if="createdByName" class="text-muted">af {{ createdByName }}</span>
                </dd>
            </dl>

            <h6 class="text-uppercase text-muted mb-2">Labels</h6>
            <dl class="row mb-0">
                <dt class="col-sm-4">Status</dt>
                <dd class="col-sm-8">
                    <b-badge :variant="labelStatusVariant">{{ labelStatusText }}</b-badge>
                </dd>

                <dt class="col-sm-4">Antal labels</dt>
                <dd class="col-sm-8">{{ okoskabet.labelCount }}</dd>

                <dt class="col-sm-4">Genereret</dt>
                <dd class="col-sm-8">
                    {{ formatDate(okoskabet.labelsGeneratedAt) }}
                    <span v-if="labelsGeneratedByName" class="text-muted">af {{ labelsGeneratedByName }}</span>
                </dd>
            </dl>
        </div>

    </b-card-body>
</template>

<script>
import mixin from "../../mixins/area";

export default {
    mixins: [mixin],
    data: () => ({
        okoskabet: null,
        loading: false
    }),
    watch: {
        "$route.params.id"() {
            this.getOkoskabet();
        }
    },
    components: {},
    computed: {
        statusVariant() {
            switch ((this.okoskabet && this.okoskabet.status || "").toLowerCase()) {
                case "delivered": return "success";
                case "registered": return "info";
                case "new": return "primary";
                case "unprocessable": return "danger";
                default: return "secondary";
            }
        },
        labelStatusText() {
            switch (this.okoskabet && this.okoskabet.labelGenerationStatus) {
                case "success": return "Genereret";
                case "partial": return "Delvist genereret";
                case "failed": return "Fejlede";
                default: return "Ikke genereret";
            }
        },
        labelStatusVariant() {
            switch (this.okoskabet && this.okoskabet.labelGenerationStatus) {
                case "success": return "success";
                case "partial": return "warning";
                case "failed": return "danger";
                default: return "secondary";
            }
        },
        createdByName() {
            return this.userName(this.okoskabet && this.okoskabet.createdBy);
        },
        labelsGeneratedByName() {
            return this.userName(this.okoskabet && this.okoskabet.labelsGeneratedBy);
        }
    },
    methods: {
        getOkoskabet() {
            if (!this.entity || !this.entity.Id) {
                return;
            }

            this.loading = true;
            this.$http.get("/api/module/orders/okoskabet/" + this.entity.Id).then(x => {
                this.okoskabet = x.data;
                this.loading = false;
            }).catch(() => {
                this.okoskabet = null;
                this.loading = false;
            });
        },
        userName(id) {
            if (!id || !this.$users) {
                return null;
            }
            var user = this.$users.find(x => x.id == id);
            return user ? user.name : null;
        },
        formatDate(date) {
            return date ? this.$moment(date).format("DD-MM-YYYY HH:mm") : "-";
        }
    },
    created() {
        this.getOkoskabet();
    },
    mounted() {}
};
</script>
